<template>
  <div class="footer-featured-brands">
    <div
      v-for="(group, index) in groups"
      :key="`group-${index}`"
      class="footer-featured-brands__column"
    >
      <h4 class="text text--h4 footer-featured-brands__headline">
        {{ group.title }}
      </h4>
      <ul class="footer-featured-brands__brands list">
        <li
          v-for="(entry, entryIndex) in group.entries"
          :key="`entry-${index}-${entryIndex}`"
          class="footer-featured-brands__brand list__element"
        >
          <LinkButton
            :to="entry.url"
            tag="nuxt-link"
            class="footer-featured-brands__link"
            no-styling
          >
            {{ entry.title }}
          </LinkButton>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LinkButton } from '@i22team/td-longtail-vue-components';

const groups = [
  {
    title: 'Smartphones',
    entries: [
      {
        title: 'Apple',
        url: '/smartphones-und-handys/smartphones/_apple',
      },
      {
        title: 'Samsung',
        url: '/smartphones-und-handys/smartphones/_samsung',
      },
      {
        title: 'XIAOMI',
        url: '/smartphones-und-handys/smartphones/_xiaomi',
      },
    ],
  },
  {
    title: 'Tablets',
    entries: [
      {
        title: 'Apple',
        url: '/tablets-und-zubehoer/tablets/_apple',
      },
      {
        title: 'Samsung',
        url: '/tablets-und-zubehoer/tablets/_samsung',
      },
    ],
  },
  {
    title: 'Zubehör',
    entries: [
      {
        title: 'Apple',
        url: '/zubehoer/_apple',
      },
      {
        title: 'Anker',
        url: '/zubehoer/_anker',
      },
      {
        title: 'agood',
        url: '/zubehoer/_agood',
      },
    ],
  },
];
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.footer-featured-brands {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-between;

  &__brand {
    @include font-size(16px, 27px);
  }

  &__brands {
    list-style: none;
  }

  &__column {
    min-width: 150px;
    flex: 1 1 calc(100% / 3 - 1rem);

    @include mq($mq-sm) {
      min-width: auto;
    }
  }

  &__headline {
    @include font-size(15px, 30px);
    font-weight: 700;
    text-align: left;
    margin-bottom: 12px;
    position: relative;
    text-transform: uppercase;
    @include mq($mq-sm) {
      @include font-size(16px, 18px);
    }
  }

  &__link {
    &:hover {
      text-decoration: 1px underline;
    }
  }
}
</style>
